import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/authContext";
import { getAuth } from "../../services/authService";

export default function Login() {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isloading, setIsloading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!login || !password) {
      setError('Por favor, preencha o login e a senha.');
      return;
    }

	setIsloading(true);
	
    try {	  		
      const user = await getAuth(login, password);
      if (user && authContext) {
        authContext.setUser(user);
        navigate("/home");
      } else {
        setError("Login ou senha inválidos.");
      }
	} catch (err) {
	  if (err instanceof Error) {
		setError(err.message || 'Erro ao realizar o login.');
	  } else {
		setError('Erro ao realizar o login.');
	  }
	}
	finally {
	  setIsloading(false);
	}
  };

  return (
    <main className="d-flex w-100">
	<div className="container d-flex flex-column">
		<div className="row vh-100">
			<div className="col-sm-10 col-md-8 col-lg-6 col-xl-5 mx-auto d-table h-100">
				<div className="d-table-cell align-middle">

					<div className="text-center mt-4">
						<h1 className="h2">Bem-vindo!</h1>
						<p className="lead">
							Entre com a sua conta para continuar
						</p>
					</div>

					<div className="card">
						<div className="card-body">
							<div className="m-sm-3">
								<form onSubmit={handleLogin}>
									<div className="mb-3">
										<label className="form-label">Login</label>
										<input
											className="form-control form-control-lg"
											type="email"
											placeholder="Email"
											value={login}
											onChange={(e) => setLogin(e.target.value)} />
									</div>
									<div className="mb-3">
										<label className="form-label">Senha</label>
										<input
											className="form-control form-control-lg"
											type="password"
											placeholder="Senha"
											value={password}
											onChange={(e) => setPassword(e.target.value)} />
									</div>
									{error && <div className="alert alert-danger text-center" role="alert">{error}</div>}
									<div className="d-grid gap-2 mt-3">
										{isloading ?
										<div className="d-flex justify-content-center">
											<div className="spinner-border text-primary" role="status">
												<span className="visually-hidden">Loading...</span>
											</div>
										</div> :
										<input type="submit" className="btn btn-lg btn-primary" value="Entrar" />}										
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</main>
  );
}
